import React from "react";

import { HomeIntro } from "../../components/Home/HomeIntro/HomeIntro";
import { Features } from "../../components/Home/HomeFeaturesSection/HomeFeaturesSection";
import { BlogsSection } from "../../components/Home/BlogsSection/BlogsSection";

import "./Home.css";

export const Home = () => (
  <div>
    <section className="intro-section">
      <HomeIntro />
    </section>

    <section className="features-section">
      <Features />
    </section>

    <section className="blog-section">
      <BlogsSection />
    </section>
  </div>
);
